const PENDING_WITHDRAWAL_STATUSES = new Set(["created", "pending", "processing"])
const SUCCESS_WITHDRAWAL_STATUSES = new Set(["completed", "success", "processed"])

export type WithdrawalOutcome =
	| { state: "waiting" }
	| { state: "success"; withdrawal: ICardWithdrawalSaved }
	| { state: "failed"; withdrawal: ICardWithdrawalSaved }

export const getNewWithdrawalOutcome = (
	withdrawals: ICardWithdrawalSaved[],
	existingIds: ReadonlySet<number>,
	expected?: { cardUid: string; amount: number; currency: string }
): WithdrawalOutcome => {
	const withdrawal = withdrawals
		.filter(
			item =>
				!existingIds.has(item.id) &&
				(!expected ||
					(item.card_uid === expected.cardUid &&
						item.amount === expected.amount &&
						(item.currency || "").toUpperCase() === expected.currency.toUpperCase()))
		)
		.sort((left, right) => Date.parse(right.created_at) - Date.parse(left.created_at))[0]
	if (!withdrawal || PENDING_WITHDRAWAL_STATUSES.has(withdrawal.status.toLowerCase())) {
		return { state: "waiting" }
	}
	if (SUCCESS_WITHDRAWAL_STATUSES.has(withdrawal.status.toLowerCase())) {
		return { state: "success", withdrawal }
	}
	return { state: "failed", withdrawal }
}
